import * as React from "react";
import { useEffect } from "react";
import { useNomaContext } from "../Contexts/MapContext";
import { useCustomViewContext } from "../Contexts/CustomViewContext";
import { IRelatedDocs } from "../interfaces";
import { CloseButton } from "../Elements/CloseButton";
import { DocumentList } from "./DocsSection";
import { Popup, PopupBody, PopupFooter, PopupHeader } from "./Popup";

export const Apply = (): JSX.Element => {
    const { isMobile, applyFeature, setApplyFeature } = useNomaContext();
    const { relatedDocs } = useCustomViewContext();

    const objectId = applyFeature.feature.get("OBJECTID");

    let objectDocs = relatedDocs.find((item: IRelatedDocs) => (item.objectId === objectId ? item.docs : undefined));

    useEffect(() => {
        objectDocs = relatedDocs.find((item: IRelatedDocs) => (item.objectId === objectId ? item.docs : undefined));
    }, [relatedDocs]);

    const popupText = "Pieteikties izsolei var nolikumā norādītajā kārtībā";

    return (
        <Popup
            id={isMobile ? "apply-popup" : applyFeature.isRight ? "apply-popup-right" : "apply-popup-left"}
            isMobile={isMobile}
            hasBackdrop={false}
        >
            <PopupHeader isMobile={isMobile}>
                {!isMobile && <div>Pieteikties izsolei</div>}
                <CloseButton onClose={() => setApplyFeature(null)}></CloseButton>
            </PopupHeader>
            <PopupBody isMobile={isMobile}>
                <div className="apply-popup-text">{popupText}</div>
                {objectDocs && objectDocs.docs && <DocumentList docs={objectDocs.docs}></DocumentList>}
            </PopupBody>
            <PopupFooter isMobile={isMobile}></PopupFooter>
        </Popup>
    );
};
